import { hasWindowsOS } from '@services/commonServices'
import { useMediaQuery } from 'react-responsive'

export default function TabletViewMediaQuery({ children }) {
  const matches = useMediaQuery({
    query:
      'only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2), only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2)'
  })

  if (typeof children === 'function') {
    return children(matches && !hasWindowsOS())
  }
  return matches ? children : null
}
